import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/styles';

export const useWidth = () => {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return keys.find((key) => useMediaQuery(theme.breakpoints.up(key)) || 'xs');
};
